export default {
  SET_SERVICES: function (state, payloads) {
    state.services = payloads;
  },
};
